import * as types from '../mutation-types'
import api from '@/api/client'
import router from "@/router";

// initial state
const state = {
    client: [],
    meta: {},
    loaded: false,
}

const getters = {
    client: state => state.client,
    clientLoaded: state => state.loaded,
}

const actions = {
    getClient({ commit }, payload) {
        commit(types.SET_CLIENT_LOADED, false );
        api.getClients(payload,(response) => {
            if(!response._embedded.Client[0]) {
                router.push('/404')
            }
            commit(types.SET_CLIENT, response._embedded.Client[0] );
            commit(types.SET_CLIENT_META, response );
            commit(types.SET_CLIENT_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_CLIENT] (state, client ) {
        state.client = client
    },
    [types.SET_CLIENT_META] (state, response ) {
        state.meta = response
    },
    [types.CLEAN_CLIENT] (state ) {
        state.client = []
    },
    [types.SET_CLIENT_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


